import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output, viewChild } from '@angular/core';
import { NgxSkeletonLoaderConfigTheme, NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Router, RouterModule } from '@angular/router';

import { Brand, NormilizedBrand } from '@models';
import { BrandComponent } from '../brand/brand.component';
import { HREF, NavigationService } from '@core';
import { AccessibleClickDirective } from '../directives/accessible-click.directive';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'lib-brands-list',
  templateUrl: './brands-list.component.html',
  styleUrls: ['./brands-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BrandComponent, RouterModule, AccessibleClickDirective, NgxSkeletonLoaderModule],
})
export class BrandsListComponent {
  readonly brands = input<NormilizedBrand[]>();
  readonly closeAction = output<void>();
  readonly href = HREF;
  readonly containerRef = viewChild<ElementRef>('container');

  router = inject(Router);
  private navigationService = inject(NavigationService);
  readonly themeService = inject(ThemeService);

  readonly skeletonConfig: NgxSkeletonLoaderConfigTheme = {
    height: '124px',
    width: '100%',
    'border-radius': '8px',
    border: '1px solid white',
  };

  clickBrand(brand: Brand): void {
    this.closeAction.emit();
    this.navigationService.goToBrandStore(brand.id);
  }
}
